import React from "react";
import "./Skills.css";

function Competences() {
  const skills = [
    { name: "HTML", level: 90, icon: "🌐" },
    { name: "CSS", level: 85, icon: "🎨" },
    { name: "JavaScript", level: 80, icon: "📜" },
    { name: "PHP", level: 75, icon: "🐘" },
    { name: "Java", level: 70, icon: "☕" },
    { name: "VB.NET", level: 65, icon: "💻" },
    { name: "C#", level: 70, icon: "🔧" },
    { name: "MongoDB", level: 60, icon: "🍃" },
    { name: "MySQL", level: 85, icon: "🐬" },
    { name: "React", level: 80, icon: "⚛️" },
    { name: "React Native", level: 75, icon: "📱" },
  ];

  return (
    <div className="competences">
      {/* Première partie : Compétences et expériences */}
      <section className="competences-experiences">
        <h1 className="section-title">Compétences et Expériences</h1>
        <p>
          Avec plus de 10 ans d'expertise, je possède des compétences solides en
          développement web, administration avancée des bases de données et
          développement d'applications. Mon expérience inclut la conception de
          solutions évolutives, l'optimisation des performances et l'intégration
          des meilleures pratiques dans divers projets.
        </p>
      </section>

      {/* Seconde partie : Outils maîtrisés */}
      <section className="competences-tools">
      <h1 className="section-title">Outils maîtrisés</h1>
        <div className="skills-grid">
          {skills.map((skill, index) => (
            <div className="skill-item" key={index}>
              <div className="skill-icon-and-name">
                <span className="skill-icon">{skill.icon}</span>
                <h2 className="skill-name">{skill.name}</h2>
              </div>
              <div className="skill-bar">
                <div
                  className="skill-level"
                  style={{ width: `${skill.level}%` }}
                >
                  {skill.level}%
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default Competences;
